import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const Funding = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  const fundingBadges = [
    { text: "BAFA bis 50 %", color: "from-accent to-accent/80" },
    { text: "AVGS 100 %", color: "from-purple-accent to-purple-accent/80" },
    { text: "INQA bis zu 80 %", color: "from-accent to-purple-accent" }
  ];

  return (
    <section id="funding" className="py-32 bg-gradient-subtle relative overflow-hidden">
      <div className="absolute inset-0 bg-dot-pattern opacity-[0.03]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" ref={ref}>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.article
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <header className="mb-6">
              <motion.h2 
                className="text-4xl md:text-5xl font-extrabold gradient-heading mb-4"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                Fördermöglichkeiten
              </motion.h2>
              <motion.div 
                className="w-20 h-1 bg-gradient-to-r from-accent to-purple-accent rounded-full mb-6"
                initial={{ scaleX: 0 }}
                animate={isInView ? { scaleX: 1 } : {}}
                transition={{ duration: 0.6, delay: 0.2 }}
              ></motion.div>
              <motion.p 
                className="text-lg text-muted-foreground"
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : {}}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                Beratung mit Förderung nutzbar – je nach Programm bis zu 100 %.
              </motion.p>
            </header>

            <div className="flex flex-wrap gap-3 mb-8">
              {fundingBadges.map((badge, index) => (
                <motion.a
                  key={badge.text}
                  href={badge.text.includes("INQA") ? "/inqa-coaching" : "/foerdermittelberatung"}
                  className={`inline-flex items-center rounded-lg bg-gradient-to-r ${badge.color} px-4 py-2 text-sm font-semibold text-white shadow-[var(--shadow-soft)] cursor-pointer`}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={isInView ? { opacity: 1, scale: 1 } : {}}
                  transition={{ duration: 0.3, delay: 0.4 + index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                >
                  {badge.text}
                </motion.a>
              ))}
            </div>

            <motion.p 
              className="text-muted-foreground leading-relaxed mb-4 text-base md:text-lg"
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              Das Beratungsprogramm INQA‑Coaching des Bundesministeriums für Arbeit und Soziales hilft kleinen und mittleren Unternehmen,
              im digitalen Wandel wettbewerbsfähig und attraktiv für Fachkräfte zu bleiben. <strong>80 % gefördert, 100 % gestärkt in die Zukunft!</strong>
            </motion.p>
            <motion.p 
              className="text-muted-foreground leading-relaxed text-base md:text-lg"
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              Gemeinsam finden wir das passende Programm und begleiten die Antragstellung: von BAFA über AVGS bis hin zu INQA – transparent, strukturiert und zielorientiert.
            </motion.p>
          </motion.article>

          <motion.aside
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            whileHover={{ y: -5 }}
          >
            <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-large)] bg-card border-2 border-border/50 hover:border-accent/30 transition-all duration-300 relative group">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-accent to-purple-accent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <img
                src="/lovable-uploads/339b6d68-8873-4b23-a1de-67eb7349b7e5.png"
                alt="INQA‑Coaching Autorisierungsurkunde – Maria Keutel, MA4Consult"
                loading="lazy"
                className="w-full h-auto"
              />
            </div>
          </motion.aside>
        </div>
      </div>
    </section>
  );
};

export default Funding;
